// @flow

import * as React from 'react';


import {
  OPINION_MAIN_FLOW, CONSULTATION_MAIN_FLOW,
  TREATMENT_COST_FLOW
} from '@routes';

import { Link, withTranslation } from '@i18n';

import type { modalProps } from './types';

import {
  AppointmentHeading,
  StyledContent,
  StyledImage,
  StyledButtonComponent,
  StyledTreatmentCostIcon,
  StyledOnlineConsultationIcon,
  StyledSecondOpinionIcon,
  ServicesText,
  ButtonWrapper,
  StyledContactUsIcon
} from './styles';

const FlowModal = ({
  setModalSlide,
  t,
  setVisible,
  handleOpen,
  setContactUs
}: modalProps): React.Node => (
  <>
    <StyledContent>
      <StyledImage src="/static/images/SmileyBusinessWomen.png" />
      <AppointmentHeading>{t('AppointmentHeading')}</AppointmentHeading>
      <ButtonWrapper>
        <Link href={TREATMENT_COST_FLOW} params={{ path: 'name' }} passHref>
          <StyledButtonComponent onClick={() => handleOpen(false)}>
            <StyledTreatmentCostIcon />
            <ServicesText>{t('TreatmentCosts')}</ServicesText>
          </StyledButtonComponent>
        </Link>

        <Link href={OPINION_MAIN_FLOW} params={{ path: 'department' }} passHref>
          <StyledButtonComponent onClick={() => handleOpen(false)}>
            <StyledSecondOpinionIcon />
            <ServicesText>{t('SecondOpinion')}</ServicesText>
          </StyledButtonComponent>
        </Link>

        <Link href={CONSULTATION_MAIN_FLOW} params={{ path: 'department' }} passHref>
          <StyledButtonComponent onClick={() => handleOpen(false)}>
            <StyledOnlineConsultationIcon />
            <ServicesText>{t('OnlineConsultation')}</ServicesText>
          </StyledButtonComponent>
        </Link>

        <StyledButtonComponent
          full
          onClick={() => {
            setModalSlide(1);
            setVisible(false);
            setContactUs(true);
          }}
          target="_blank"
        >
          <StyledContactUsIcon />
          <ServicesText>{t('ContactUs')}</ServicesText>
        </StyledButtonComponent>
      </ButtonWrapper>
    </StyledContent>
  </>

  // </StyledOuterModalWrapper>
);

export default withTranslation('FlowModal')(FlowModal);
